
import { atom } from '@zedux/react'

const invoiceEditorModeAtom = atom('editorModeAtom', "edit_invoice"); // valid option are: edit_invoice, select_customer or select_business

export default invoiceEditorModeAtom;
